import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'react-final-form';
import FormCheckboxGroup from 'Shared/components/FormComponents/FormCheckboxGroup';
import Avatar from 'Shared/components/Avatar/Avatar';

import { getUsersFromWorkspaces } from '../../utils';
import Collapsed from '../Collapsed';

const labelComponent = (avatar, label) => (
  <div className="d-flex" style={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
    <Avatar avatar={avatar} height={25} />
    <p className="mx-2 my-0">{label}</p>
  </div>
);

function optionsDecorator(options) {
  return options.map(user => ({ value: user.id, label: labelComponent(user.avatar, user.firstName || user.email) }));
}

type Props = {
  name: string;
  title: string;
};

export default function UsersFilter({ name, title }: Props) {
  const workspaces = useSelector(state => state.workspaces);

  const users = getUsersFromWorkspaces(workspaces);

  const [isAllResults, setIsAllResults] = useState(users.length <= 3);

  const options = optionsDecorator(isAllResults ? users : users.slice(0, 3));

  const handleAllResultsToggle = useCallback(() => setIsAllResults(!isAllResults), [isAllResults]);

  if (!options.length) return null;

  return (
    <div className="d-flex flex-column">
      <Collapsed title={title}>
        <Field name={name} options={options} component={FormCheckboxGroup} />
        {!isAllResults ? (
          <button className="btn btn-link text-left p-0 " type="button" onClick={handleAllResultsToggle}>
            More...
          </button>
        ) : null}
      </Collapsed>
    </div>
  );
}
